import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { ReactComponent as CheckIcon } from '../../assets/images/svg/check-circle-blue.svg';
import { pxToRem } from '../../assets/styles/helper';
import themeColors from '../../assets/styles/themeColors';

const ToastContainer = styled.div`
  display: flex;
  gap: ${pxToRem(12)};
  padding: ${pxToRem(12)};
  border-left: 5px solid #00b299;
  background-color: ${themeColors.colorWhite};
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: flex-start;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const Title = styled.div`
  font-weight: 500;
  font-size: ${pxToRem(16)};
  color: #001739;
`;

const Message = styled.div`
  font-size: ${pxToRem(14)};
  color: ${themeColors.colorTextSecondary};
  margin-top: ${pxToRem(2)};
`;

export const CustomToast = ({ title, message }) => (
  <ToastContainer>
    <IconWrapper>
      <CheckIcon />
    </IconWrapper>

    <ContentWrapper>
      <Title>{title}</Title>
      <Message>{message}</Message>
    </ContentWrapper>
  </ToastContainer>
);

CustomToast.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string,
};
